import InfoHeader from "./UI/InfoHeader";

export default InfoHeader